import React, {useState, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {Button} from "react-bootstrap";
import {myService} from '@app/services/sukienService';
import {alertService} from '@app/services/alertService';
import {ClipLoader} from "react-spinners";
import NhadanchitietEditModal from './NhadanchitietEditModal';
import {getFormData} from "@app/utils/CommonFunctions";
import {uploadService} from "@app/services/uploadService";
import ImportErrorTable from "@pages/FUtil/ImportErrorTable";

const NhadanchitietEdit = ({id, allowEdit}) => {
    const [loading, setLoading] = useState(false);
    const [handleToogle, setHandleToogle] = useState(false);
    const [t] = useTranslation();
    const [nhadanchitietList, setNhadanchitietList] = useState([]);
    const [isViewNhadanchitiet, setIsViewNhadanchitiet] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedObj, setSelectedObj] = useState(null);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [importErrors, setImportErrors] = useState([]);
    const [importErrorsTitle, setImportErrorsTitle] = useState('');
    const [importcolumnError, setImportcolumnError] = useState('');

    const importClick = async () => {
        if (!fileUpload) {
            alertService.error("Vui lòng chọn file");
            return;
        }

        setLoading(true);
        const form = getFormData({ fileUpload, uploadType: 'SUKIEN_NHADAN_TYPE', secret_key: id });

        try
        {
            const result = await uploadService.ImportStandard(form);
            if (result) {
                if (result.status === "1") {
                    alertService.success(result.msg);
                    // Refresh the data after successful import
                    await loadRef();
                    // Clear the file input
                    setFileUpload(null);
                    const fileInput = document.getElementById('fileUpload');
                    if (fileInput) fileInput.value = '';
                } else {
                    // Show dynamic table with error data
                    setImportErrors(result.data || []);
                    setImportErrorsTitle(result.msg || 'Import thất bại')
                    setImportcolumnError(result.data2 || '')
                    setShowErrorModal(true);
                    alertService.error(result.msg || 'Import thất bại');
                }
            } else {
                alertService.error('Có lỗi xảy ra trong quá trình import');
            }
        } catch (error) {
            console.error('Import error:', error);
            alertService.error('Có lỗi xảy ra trong quá trình import');
        } finally {
            setLoading(false);
        }
    };
    /// upload
    const [fileUpload, setFileUpload] = useState(null);
    // Simplified input change handler
    const onchangeInput = async (name, e) => {
        const { files} = e.target;
        setFileUpload(files[0]);
    }

    const loadRef = async () => {
        setLoading(true);
        try {
            const tmp = await myService.getRefById(id, 'sukien_nhadanchitiet', {});
            setNhadanchitietList(tmp);
            setIsViewNhadanchitiet(true);
            setHandleToogle((prevSelected) => {
                return !prevSelected;
            });
        } catch (error) {
            alertService.error('Có lỗi xảy ra khi tải dữ liệu');
        }
        setLoading(false);
    };

    const editdonhang = (rowIndex) => {
        setSelectedObj({...nhadanchitietList[rowIndex]});
        setShowModal(true);
    };

    const deletedonhang = async (rowIndex) => {
        const { id: itemId } = nhadanchitietList[rowIndex]
        try {
            const result = await myService.Delete_Nhadanchitiet(itemId);
            if (result.status === "1") {
                alertService.success(t('fields.label.xoathanhcong'));
                await loadRef();
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            alertService.error('Có lỗi xảy ra khi xóa dữ liệu');
        }
    };

    const handleModalHide = () => {
        setShowModal(false);
        setSelectedObj(null);
    };

    const handleModalSuccess = async () => {
        // Refresh the list after successful create/update
        await loadRef();
    };

    const handleAddNew = () => {
        setSelectedObj(null); // null means new record
        setShowModal(true);
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

    return <>
        {isViewNhadanchitiet ? (
            <Button
                className="btn btn-secondary mr-1"
                aria-label="Close"
                onClick={() => { setIsViewNhadanchitiet(false); setNhadanchitietList([]) }}
            >
                <span aria-hidden="true">Ẩn</span>
            </Button>
        ) : (
            <Button className="btn btn-info mr-1" onClick={() => loadRef()}>
                <i className="fa fa-arrow-down"> {"Xem"}</i>
            </Button>
        )}

        { allowEdit && isViewNhadanchitiet && (
            <Button
                className="btn btn-success mr-1"
                icon="right fas fa-angle-left"
                onClick={handleAddNew}
            >
                <i className="fa fa-save"> {"Thêm"} </i>
            </Button>
        )}

        {
            allowEdit && isViewNhadanchitiet && ( <div className="row">

                <div className="col-md-4">
                    <label className="required"htmlFor="fileUpload">Import dữ liệu</label>
                    <div className="input-group">
                        <input
                            id='fileUpload'
                            name="fileUpload"
                            type="file"
                            className="form-control  mr-1"
                            onChange={(e) => onchangeInput('fileUpload', e)}
                        />
                        <Button
                            type="button"
                            className="btn btn-success"
                            onClick={importClick}
                        >
                            <i className="fa fa-plus"></i> Upload
                        </Button>
                    </div>
                </div>
            </div>)
        }

        <hr/>

        {isViewNhadanchitiet && (
            <div className="row table-responsive">
                <div className="col-md-12">
                    <table responsive bordered hover className="table table-bordered table-hover text-nowrap">
                        <thead>
                        <tr>
                            <th className="col-md-1 text-center">Nhà đàn</th>
                            <th className="col-md-1 text-center">Nhóm sự kiện</th>
                            <th className="col-md-1 text-center">Phân loại sự kiện</th>
                            <th className="col-md-1 text-center">Đốt sở</th>
                            <th className="col-md-1 text-center">Xin keo</th>
                            <th className="col-md-1 text-center">Hình thức</th>
                            <th className="col-md-1 text-center">Kết quả</th>
                            <th className="col-md-1 text-center">Tác vụ</th>
                        </tr>
                        </thead>
                        <tbody>
                        {nhadanchitietList && nhadanchitietList.length > 0 && nhadanchitietList.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td className="text-center">
                                        <div className="form-group">
                                            <div className="form-control d-flex align-items-center">
                                                {item.nha_dan}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <div className="form-group">
                                            <div className="form-control d-flex align-items-center">
                                                {item.nhom_su_kien}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <div className="form-group">
                                            <div className="form-control d-flex align-items-center">
                                                {item.phan_loai_su_kien}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <div className="form-group">
                                            <div className="form-control d-flex align-items-center">
                                                {item.dot_so}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <div className="form-group">
                                            <div className="form-control d-flex align-items-center">
                                                {item.xin_keo}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <div className="form-group">
                                            <div className="form-control d-flex align-items-center">
                                                {item.hinh_thuc}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <div className="form-group">
                                            <div className="form-control d-flex align-items-center">
                                                {item.ket_qua}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        { allowEdit && (<a
                                            className="btn"
                                            key={`delete-nhadanchitiet-${index}`}
                                            title={t('action.label.delete')}
                                            onClick={() => {
                                                if (window.confirm(t('fields.label.bancomuonxoa')))
                                                    deletedonhang(index);
                                            }}
                                        >
                                            <i className="fas fa-times-circle text-danger mr-2" />
                                        </a>) }
                                        <a
                                            className="btn btn-warning btn-sm mr-2"
                                            key={`edit-nhadanchitiet-${index}`}
                                            title={t('action.label.edit')}
                                            onClick={() => editdonhang(index)}
                                        >
                                            <i className="fas fa-pencil-alt" />
                                        </a>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        )}

        <NhadanchitietEditModal
            showModal={showModal}
            initialObj={selectedObj}
            allowEdit={allowEdit}
            onHide={handleModalHide}
            onSuccess={handleModalSuccess}
            parentId={id}
        />
        <ImportErrorTable
            columnError = {importcolumnError}
            show={showErrorModal}
            onHide={() => setShowErrorModal(false)}
            data={importErrors}
            title={importErrorsTitle}
            column
        />
    </>
};

export default NhadanchitietEdit;